



































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { NavBar, Row, Icon, Button } from "vant";
import WeMixin from "@/components/weMixin";
import { CoreModule } from "@/store/modules/core";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
})
export default class AutoAuthPagePage extends mixins(WeMixin) {
  // private rTime: number = 5;
  private rTime: number = 0;

  protected created() {
    this.countDown();
  }

  protected countDown() {
    const interval = window.setInterval(() => {
      if (--this.rTime <= 0) {
        window.clearInterval(interval);
        this.goBack();
      }
    }, 0);
  }

  protected goBack() {
    if (CoreModule.to) {
      this.$router.replace(CoreModule.to);
    } else {
      this.weGoHome();
    }
  }
}
